import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import Qcomponent from './Qcomponent'

@observer
export default class extends Component {
  render() {
    const header = ['小程序', '帮助']
    return (
      <HeaderView header={header} title="帮助">
        <div className={styles.itemWrap}>
          <Qcomponent title="小程序是什么，能详细介绍一下吗？">
            <p className={styles.answer}>
              小程序是一种不需要下载安装即可使用的应用，它实现了应用“触手可及”的梦想，用户扫一扫或者搜一下即可打开应用。用户不用关心是否安装太多应用的问题。应用将无处不在，随时可用，但又无需安装卸载。
            </p>
          </Qcomponent>

          <Qcomponent title="所有商家都可以开通小程序吗？">
            <p className={styles.answer}>
              是的，所有的婚礼纪商家都可以使用小程序。
            </p>
          </Qcomponent>

          <Qcomponent title="小程序的收费是怎样的，之后续费还是1299这个价格吗？">
            <p className={styles.answer}>
              微店小程序限时特价1299，原价1999，活动之后将会恢复原价，之后续费可能会根据市场情况做相应的价格调整。相比市场上动辄2～3万的小程序开发费用，婚礼纪啊微店小程序绝对是性价比的不二之选。
            </p>
          </Qcomponent>

          <Qcomponent title="怎么开通小程序？">
            <p className={styles.answer}>
              若商家已有小程序，点击婚礼纪小程序产品介绍页开通按钮，扫码支付后点击授权即可开通；若商家没有小程序，则可以先在微信小程序官网（<a
                href="https://mp.weixin.qq.com/wxopen/waregister?action=step1"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://mp.weixin.qq.com/wxopen/waregister?action=step1
              </a>）注册一个微信小程序帐号，之后再购买婚礼纪小程序产品。
            </p>
          </Qcomponent>

          <Qcomponent title="有已经做好的小程序展示示例吗？">
            <p className={styles.answer}>
              <img
                src="http://qnm.hunliji.com/o_1br3o78ui7hi18v61cib1mhs1l2o7.png"
                width="160"
                alt=""
              />
            </p>
          </Qcomponent>

          <Qcomponent title="小程序开通后可以在哪里展示呢？">
            <p className={styles.answer}>
              小程序展示入口有：1、微信【发现栏】入口 2、微信小程序扫码入口
              3、微信搜索页面模糊搜索 4、好友分享和群分享
              5、公众号自定义菜单跳转小程序 6、微信钱包【第三方服务】
              7、附近的小程序 等等。微信还会推出更多的流量入口，帮助引流。
            </p>
          </Qcomponent>

          <Qcomponent title="用户可以通过小程序进行下单吗？">
            <p className={styles.answer}>
              暂时不支持线上成单，但是用户可以通过小程序进行咨询、预约、留电话等，用户进行的预约会收录在商家后台预约管理中。
            </p>
          </Qcomponent>

          <Qcomponent title="一个店铺可以生成多个小程序吗？">
            <p className={styles.answer}>
              一个店铺只能生成一个小程序，微信规定“企业、政府、媒体、其他组织主体可以注册50个小程序，个体户主体可注册5个小程序”。如需生成多个小程序，可以到微信进行注册，然后再开通到其他店铺上进行使用。
            </p>
          </Qcomponent>

          <Qcomponent title="小程序名称头像设置相关问题">
            <p className={styles.answer}>
              小程序名称、头像仅能在微信公众号平台进行设置，小程序在正式发布前，有两次改名的机会，一旦发布后，将不再支持修改名称。小程序介绍一个月内可申请5次修改。服务范围选择：可申请不少于1个不多于5个服务范围，服务范围分两级，每级不能为空。特殊行业需提示特殊资质。一个月内可修改一次。
            </p>
          </Qcomponent>

          <Qcomponent title="附近小程序是否需要有门店？">
            <p className={styles.answer}>
              按微信官方给的规则，应该是不需要门店的，附近小程序可能是某个机构或者组织，不一定都有门店，只要有经营资质，相同主体并且地址跟资质对应即可，商家可以先提交给微信进行审核，看微信那边的回复。
            </p>
          </Qcomponent>

          <Qcomponent title="微信小程序支持多门店吗？">
            <p className={styles.answer}>
              暂时无法匹配，后续会进行优化，请关注婚礼纪产品动态。
            </p>
          </Qcomponent>

          <Qcomponent title="更改小程序需要重新发布吗？">
            <p className={styles.answer}>
              如通过商家店铺后台配置套餐、案例、发布动态等，更改小程序商品内容的显示，是不需要重新发布的；
              如想要对小程序里面的内容做二次开发，如修改店铺头图等，需要重新审核发布。
            </p>
          </Qcomponent>
        </div>
      </HeaderView>
    )
  }
}
